import { CoreMenu } from "src/@core/types";

export const invoicingMenu: CoreMenu[] = [
    {
        id: 'Setup',
        title: 'Setup',
        type: 'collapsible',
        icon: 'setup.svg',
        role: {
            roles: ['employee'],
            right: ['P1025', 'P1047', 'P1076', ],
        },
        children: [
            {
                id: 'Customer',
                title: 'Customer',
                type: 'item',
                icon: 'customers.svg',
                url: '/invoicing/customer',
                role: {
                    roles: ['employee'],
                    right: 'P1025',
                },
            },
            {
                id: 'Service',
                title: 'Service',
                type: 'item',
                icon: 'service.svg',
                url: '/invoicing/service',
                role: {
                    roles: ['employee'],
                    right: 'P1047',
                },
            },
            {
                id: 'Product',
                title: 'Product',
                type: 'item',
                icon: 'modules.svg',
                url: '/invoicing/product',
                role: {
                    roles: ['employee'],
                    right: 'P1076',
                },
            },
            {
                id: 'Payment-Terms',
                title: 'Payment Term',
                type: 'item',
                icon: 'test-result.svg',
                url: '/invoicing/payment-terms',
                role: {
                    roles: ['employee'],
                    right: 'adjhfkhdkhls',
                },
                exactMatch: true,
            },
        ],
    },
    {
        id: 'AgreementMenu',
        title: 'Agreement',
        type: 'collapsible',
        icon: 'agreement.svg',
        role: {
            roles: ['employee'],
            right: ['P1000', 'P1098', 'P1113', 'P'],
        },
        children: [
            {
                id: 'AgreementList',
                title: 'Agreement',
                type: 'item',
                icon: 'agreement.svg',
                url: '/invoicing/agreement',
                role: {
                    roles: ['employee'],
                    right: 'P1000',
                },
                exactMatch: true,
            },
            // {
            //     id: 'AgreementServiceList',
            //     title: 'Agreement Service',
            //     type: 'item',
            //     icon: 'service.svg',
            //     url: '/invoicing/agreement/service',
            //     role: {
            //         roles: ['employee'],
            //         right: 'P1000',
            //     },
            // },
            {
                id: 'Agreement-Template',
                title: 'Agreement Template',
                type: 'item',
                icon: 'letter-template.svg',
                url: '/invoicing/template/agreement',
                role: {
                    roles: ['employee'],
                    right: 'P1098',
                },
            },
            {
                id: 'Agreement-ETemplate',
                title: 'Agreement Email Template',
                type: 'item',
                icon: 'letter-template.svg',
                url: '/invoicing/email/template/agreement',
                role: {
                    roles: ['employee'],
                    right: 'P1113',
                },
            },
            {
                id: 'AgreementStatus',
                title: 'Agreement Status',
                type: 'item',
                icon: 'status.svg',
                url: '/invoicing/status/agreement',
                role: {
                    roles: ['employee'],
                    right: 'asdfasdfsda',
                },
            },
            // {
            //     id: 'AgreementServiceStatus',
            //     title: 'Agreement Service Status',
            //     type: 'item',
            //     icon: 'status.svg',
            //     url: '/invoicing/status/agreement-service',
            //     role: {
            //         roles: ['employee'],
            //         right: 'P',
            //     },
            // },
        ],
    },
    {
        id: 'InvoicesMenu',
        title: 'Invoice',
        type: 'collapsible',
        icon: 'invoice.svg',
        role: {
            roles: ['employee'],
            right: ['P1011', 'P1143', 'P1188'],
        },
        children: [
            {
                id: 'InvoiceList',
                title: 'Invoice',
                type: 'item',
                icon: 'invoice.svg',
                url: '/invoicing/invoice',
                role: {
                    roles: ['employee'],
                    right: 'P1011',
                },
                exactMatch: true,
            },
            // {
            //     id: 'InvoiceSettings',
            //     title: 'Invoice Settings',
            //     type: 'item',
            //     icon: 'policy-types.svg',
            //     url: '/invoicing/invoice/settings',
            //     role: {
            //         roles: ['employee'],
            //         right: 'P1011',
            //     },
            // },
            {
                id: 'InvoiceReminder',
                title: 'Invoice Reminder',
                type: 'item',
                icon: 'calendar.svg',
                url: '/invoicing/invoice/reminder',
                role: {
                    roles: ['employee'],
                    right: 'P1011',
                },
            },
            {
                id: 'Invoicing-Template',
                title: 'Invoicing Template',
                type: 'item',
                icon: 'letter-template.svg',
                url: '/invoicing/template/invoice',
                role: {
                    roles: ['employee'],
                    right: 'P1143',
                },
            },
            {
                id: 'Invoicing-ETemplate',
                title: 'Invoicing Email Template',
                type: 'item',
                icon: 'letter-template.svg',
                url: '/invoicing/email/template/invoice',
                role: {
                    roles: ['employee'],
                    right: 'P1188',
                },
            },
            // {
            //     id: 'InvoiceStatus',
            //     title: 'Invoice Status',
            //     type: 'item',
            //     icon: 'status.svg',
            //     url: '/invoicing/status/invoice',
            //     role: {
            //         roles: ['employee'],
            //         right: 'P',
            //     },
            // },
            // {
            //     id: 'ReminderStatus',
            //     title: 'Reminder Status',
            //     type: 'item',
            //     icon: 'status.svg',
            //     url: '/invoicing/status/reminder',
            //     role: {
            //         roles: ['employee'],
            //         right: 'P',
            //     },
            // },
        ],
    },
    {
        id: 'Email-Menu',
        title: 'Email Settings',
        type: 'collapsible',
        icon: 'email-log.svg',
        role: {
            roles: ['employee'],
            right: ['P1230', 'P1249'],
        },
        children: [
            {
                id: 'Email-Logs',
                title: 'Email Logs',
                type: 'item',
                icon: 'email-log.svg',
                url: '/invoicing/email/logs',
                role: {
                    roles: ['employee'],
                    right: 'P1230',
                },
            },
            {
                id: 'Email-Setting',
                title: 'Email Setting',
                type: 'item',
                icon: 'settings.svg',
                url: '/invoicing/email/settings',
                role: {
                    roles: ['employee'],
                    right: 'P1249',
                },
            },
        ],
    },
];
